var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowClientActivity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 4.5,
    stroke: "#FFD700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3307 13.9935C28.3307 18.5958 24.5997 22.3268 19.9974 22.3268C15.395 22.3268 11.6641 18.5958 11.6641 13.9935C11.6641 9.39111 15.395 5.66016 19.9974 5.66016C24.5997 5.66016 28.3307 9.39111 28.3307 13.9935Z",
    stroke: "#FFD700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "0.46 3.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 13.9935C28.3333 9.39111 24.6023 5.66016 20 5.66016",
    stroke: "#FFD700",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5V14.8333H23.3333",
    stroke: "#FFD700",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowClientActivity);
export default __webpack_public_path__ + "static/media/Yellow_ ClientActivity.5f12842fc750a94d51ecc7c5806e0d0a.svg";
export { ForwardRef as ReactComponent };